export default function Badge({
  children,
  variant = "default",
  className = "",
}: {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "danger" | "outline";
  className?: string;
}) {
  const base =
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";

  const variants: any = {
    default: "bg-black text-white",
    secondary: "bg-gray-200 text-gray-700",
    danger: "bg-red-500 text-white",
    outline: "border border-gray-300 text-gray-700",
  };

  return (
    <span className={`${base} ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}